export const sidebarLinks = [
  {
    imgURL: "/assets/icons/home.svg",
    route: "/home",
    label: "Home",
    requiresAuth: false, // Public - anyone can view
  },
  {
    imgURL: "/assets/icons/home.svg",
    route: "/trust-score",
    label: "Trustscore Dashboard",
    requiresAuth: true, // Private - requires login
  },
  {
    imgURL: "/assets/icons/explore.svg",
    route: "/explore",
    label: "Explore",
    requiresAuth: false, // Public - anyone can view
  },
  {
    imgURL: "/assets/icons/message.svg",
    route: "/chats",
    label: "Messages",
    requiresAuth: true, // Private - requires login
  },
  /* Live shopping entry point deferred; retain for a future release.
  {
    imgURL: "/assets/icons/live.svg",
    route: "/live",
    label: "Live Stream",
    requiresAuth: false, // Public - anyone can watch
  },
  */
  {
    imgURL: "/assets/icons/business-owner.svg",
    route: "/dealers",
    label: "Dealers",
    requiresAuth: false, // Public - anyone can view sellers
  },
  /*
  {
    imgURL: "/assets/icons/marketing.svg",
    route: "/bizz",
    label: "Bizz",
    requiresAuth: true, // Private - requires login
  },
  */
  {
    imgURL: "/assets/icons/bookmark.svg",
    route: "/saved",
    label: "Saved",
    requiresAuth: true, // Private - requires login
  },
  {
    imgURL: "/assets/icons/gallery-add.svg",
    route: "/create-post",
    label: "Create Post",
    requiresAuth: true, // Private - requires login
  },
  {
    imgURL: "/assets/icons/terms_conditions.svg",
    route: "/termandcondition",
    label: "Terms & Conditions",
    requiresAuth: false, // Public - anyone can view
  },
  {
    imgURL: "/assets/icons/privacy_policy.svg",
    route: "/privacy-policies",
    label: "Privacy Policy",
    requiresAuth: false, // Public - anyone can view
  },
  {
    imgURL: "/assets/icons/book-open.svg",
    route: "/busiconn-guide",
    label: "User Guide",
    requiresAuth: false, // Public - anyone can view
  }
];

export const bottombarLinks = [
  {
    imgURL: "/assets/icons/home.svg",
    route: "/home",
    label: "Home",
    requiresAuth: false, // Public - anyone can view
  },
  {
    imgURL: "/assets/icons/explore.svg",
    route: "/explore",
    label: "Explore",
    requiresAuth: false, // Public - anyone can view
  },
  /*
  {
    imgURL: "/assets/icons/marketing.svg",
    route: "/bizz",
    label: "Bizz",
    requiresAuth: true, // Private - requires login
  },
  */
  /* Live shopping entry point deferred; retain for a future release.
  {
    imgURL: "/assets/icons/live.svg",
    route: "/live",
    label: "Live",
    requiresAuth: false, // Public - anyone can watch
  },
  */
  {
    imgURL: "/assets/icons/gallery-add.svg",
    route: "/create-post",
    label: "Add Post",
    requiresAuth: true,
  },
  {
    imgURL: "/assets/icons/message.svg",
    route: "/chats",
    label: "Chats",
    requiresAuth: true, // Private - requires login
  },
  {
    imgURL: "/assets/icons/user.svg",
    route: "/profile",
    label: "Profile",
    requiresAuth: true, // Private - requires login
  },
];
